import { render } from "./HappyHour.vue?vue&type=template&id=399b52c4&scoped=true"
import script from "./HappyHour.vue?vue&type=script&lang=js"
export * from "./HappyHour.vue?vue&type=script&lang=js"

import "./HappyHour.vue?vue&type=style&index=0&id=399b52c4&lang=scss&scoped=true"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399b52c4"]])

export default __exports__